import React from 'react';
import topbarBg from '../assets/topbar-bg.png';

const Topbar = () => {
  return (
    <div className="topbar">
      <img src={topbarBg} alt="Topbar background" />
    </div>
  );
};

export default Topbar;
